import type { Config } from '@brighterion/types/config';
import {
    initUploaderService,
    initRulesService,
    initTenantService,
    initReportsService,
    initRepositoryService,
    initSimulationsService,
    initConfigService,
    initTenantManagementService,
    initTppService,
    initListService,
    initListEntryService,
    initParametersService,
    initRuleSetService,
    initRuleTesterService,
    initImportExportService
} from 'Services';

export const initServices = async (config: Omit<Config, 'auth'>) => {
    [
        initUploaderService,
        initRulesService,
        initTenantService,
        initReportsService,
        initRepositoryService,
        initSimulationsService,
        initConfigService,
        initTenantManagementService,
        initTppService,
        initListService,
        initListEntryService,
        initParametersService,
        initRuleSetService,
        initRuleTesterService,
        initImportExportService
    ].forEach((fn) => {
        fn(config);
    });
};
